import { humanPsychologyApi } from "../../../config";


export const fetchPublicPsychologyVendor = async () => {
    try {
        const res = await humanPsychologyApi.get('/Psychology/get-all-doctors');
        return res;
    } catch (error: any) {
        console.log("Error while fetching public psychology vendor", error.response.data.message);
        return error;
    }
}

export const fetchPublicPsychologyProfileData = async (mentorId: string) => {
    try {
        const res = await humanPsychologyApi.get(`/Psychology/get-public-profile/${mentorId}`);
        return res;
    } catch (error: any) {
        console.log("Error while fetching public psychology profile data", error.response?.data?.message);
        return error;
    }
}

export const fetchPublicPsychologyConsultations = async (mentorId: string) => {
    try {
        const res = await humanPsychologyApi.get(`/Psychology/get-doctor-session/${mentorId}`);
        return res;
    } catch (error: any) {
        console.log("Error while fetching public psychology consultations", error.response?.data?.message);
        return error;
    }
}

export const bookSession = async (bookinPayload: any) => {
    try {
        const res = await humanPsychologyApi.post('/Psychology/book-session', bookinPayload);
        return res.data;
    } catch (error: any) {
        console.log("Error while booking session", error.response?.data?.message);
        return error.response?.data || error;
    }
}

export const verifySessionPayment = async (payload: any) => {
    try {
        const res = await humanPsychologyApi.post('/Psychology/verify-session-payment', payload);
        return res.data;
    } catch (error: any) {
        console.log("Error while verifying session payment", error.response?.data?.message);
        return error.response?.data || error;
    }
}

export const toggleLikeSessionApi = async (sessionId: string) => {
    try {
        const res = await humanPsychologyApi.post('/Psychology/like-session', { sessionId });
        return res.data;
    } catch (error: any) {
        console.log("Error while toggling like for session", error.response?.data?.message);
        return error.response?.data || error;
    }
}